import { LabelAlignment, LabelPlacement } from '../FormField';
import { TextSize } from '../Text';
import { ConstantOf } from '../utils/typeUtils';

const prefix = 'fieldset';

export const dataHooks = {
  suffix: `${prefix}-suffix`,
  labelIndicators: `${prefix}-indicators`,
  counter: `${prefix}-counter`,
  children: `${prefix}-children`,
  label: `${prefix}-label`,
  asterisk: `${prefix}-asterisk`,
  infoIcon: `${prefix}-infoicon`,
  statusMessage: `${prefix}-statusmessage`,
};

export const LEGEND_PLACEMENT = {
  NONE: 'none',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
} satisfies ConstantOf<LabelPlacement | 'none'>;

export const LEGEND_ALIGNMENT = {
  MIDDLE: 'middle',
  TOP: 'top',
} satisfies ConstantOf<LabelAlignment>;

export const STATUS_TYPE = {
  ERROR: 'error',
  WARNING: 'warning',
} as const;

export const LEGEND_SIZE = {
  SMALL: 'small',
  TINY: 'tiny',
} satisfies ConstantOf<Extract<TextSize, 'small' | 'tiny'>>;

export const ALIGNMENT = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
} as const;

export const DIRECTION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;

export const GAP = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;
